'use client';

import { useOrientationSuggestion } from '@/hooks/useOrientationSuggestion';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ButtonShadcn } from './ui/button-shadcn';
import { useTranslation } from 'react-i18next';
import { IoIosPhonePortrait } from 'react-icons/io';

export const OrientationSuggestion = () => {
  const { showSuggestion, dismissSuggestion } = useOrientationSuggestion();
  const { t } = useTranslation();

  return (
    <Dialog
      open={showSuggestion}
      onOpenChange={(open) => !open && dismissSuggestion()}
    >
      <DialogContent className='max-w-[calc(100vw-2rem)] sm:max-w-sm'>
        <DialogHeader className='text-center'>
          <div className='mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-zinc-100'>
            <IoIosPhonePortrait className='text-3xl text-zinc-600 animate-[phoneRotate_2s_ease-in-out_infinite]' />
          </div>
          <style jsx>{`
            @keyframes phoneRotate {
              0%, 100% { transform: rotate(0deg); }
              50% { transform: rotate(90deg); }
            }
          `}</style>
          <DialogTitle>{t('orientationSuggestion.title')}</DialogTitle>
          <DialogDescription className='text-center'>
            {t('orientationSuggestion.description')}
          </DialogDescription>
        </DialogHeader>
        <div className='flex gap-3 mt-4'>
          <ButtonShadcn
            onClick={dismissSuggestion}
            variant='blue'
            className='flex-1'
          >
            {t('orientationSuggestion.gotIt')}
          </ButtonShadcn>
        </div>
      </DialogContent>
    </Dialog>
  );
};
